import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  Button,
  Modal,
} from 'react-bootstrap';
// components
import PropertyForm, { PropertyFormType as FormType } from './PropertyForm';
// validation
import { PropertyFormValidation } from '../../tools/Validations';

import './PropertyDialog.css';

export const PropertyFormType = FormType;

const PropertyDialog = observer(
class PropertyDialog extends Component {
  constructor(props) {
    super(props);
    let {
      validation = new PropertyFormValidation(),
      property,
    } = props;
    this.canSave = false;
    this.formValidation = validation;
    this.formValidation.test(property);
    this.state = { disableSaveButton: false };
  }

  render() {
    let {
      show = false,
      formType = PropertyFormType.New,
      property,
      onSave,
    } = this.props;
    const disableSaveButton = this.state.disableSaveButton || !this.formValidation.passAllValidations();
    const modalTitle = (formType === FormType.New) ? "New property" : property.name;

    return (
      <Modal show={show} onHide={this.onCancel}>
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PropertyForm
            formType={formType}
            property={property}
            onSave={onSave}
            validation={this.formValidation} />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.onCancel} >Cancel</Button>
          <Button
            bsStyle="primary"
            onClick={this.onSave}
            disabled={disableSaveButton}>Save</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  onSave = (e) => {
    e.preventDefault();
    this.disableSaveButton();
    let {
      property,
      onSave,
    } = this.props;
    if (onSave && this.formValidation.passAllValidations()) {
      onSave(property);
    }
    this.disableSaveButton(false);
    return false;
  }

  onCancel = () => {
    this.formValidation.reset();
    let { onCancel } = this.props;
    if (onCancel) {
      onCancel();
    }
  }

  disableSaveButton = (bDisable = true) => {
    this.setState({ disableSaveButton : bDisable });
  }
});

export default PropertyDialog;


// WEBPACK FOOTER //
// ./src/components/Property/PropertyDialog.js